import { useNavigate } from 'react-router-dom';

// Main area on desktop when no conversation is open
export default function EmptyState() {
  const navigate = useNavigate();
  return (
    <div className="flex h-full flex-col items-center justify-center px-6 text-center">
      <div className="mb-3 animate-splash-pulse bg-brand-text bg-clip-text font-display text-5xl font-black tracking-[5px] text-transparent">
        BLOBL
      </div>
      <div className="mb-2 font-display text-xl font-extrabold text-text">Select a conversation</div>
      <div className="mb-6 max-w-xs text-sm leading-relaxed text-text-muted">
        Pick a chat on the left, or find someone to start a new one. Servers are coming soon.
      </div>
      <button
        type="button"
        onClick={() => navigate('/dm?search=1')}
        className="cursor-pointer rounded-pill border-0 bg-brand px-7 py-3 font-display text-[15px] font-bold text-white shadow-button"
      >
        Start a conversation
      </button>
    </div>
  );
}
